import {loadCommunity} from "actions/supplementaryAction";
import {get} from "lodash";
import {connect} from 'react-redux';
import MoreInfo from "views/MoreInfo";

const mapStateToProps = ({supplementary: {community, faqTopics}, profile: {displayName}, auth: {user}}) => ({
  community,
  displayName,
  firstName: get(user, 'firstName'),
  role: get(user, 'role'),
  faqTopics,
});

export default connect(mapStateToProps, {loadCommunity})(MoreInfo);
